module.exports = __webpack_public_path__ + "media/images/suppliers/genomeme-3e3335c14281a286fc43a8a6722ba57e.png";